import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { v4 as uuid } from "uuid";

import { store } from "state";
import { INewsletterOption } from "types";

import { NewsletterFormContainer } from "./containers";

(() => {
  const newsletterFormContainers = document.querySelectorAll<HTMLLIElement>(
    "[data-newsletter-form]"
  );

  if (!newsletterFormContainers) return;

  Array.from(newsletterFormContainers).forEach((newsletterFormContainer) => {
    const data = newsletterFormContainer.dataset.newsletterForm;
    newsletterFormContainer.dataset.newsletterForm = ""; // cleanup

    if (!data) return;

    const props = JSON.parse(data);
    const { newsletters } = props;

    ReactDOM.render(
      <Provider store={store}>
        {/* (!) Unique ID is required to make input field IDs unique */}
        <NewsletterFormContainer
          id={uuid()}
          {...props}
          newsletters={newsletters.filter(
            (newsletter: INewsletterOption) => !!newsletter.audience
          )}
        />
      </Provider>,
      newsletterFormContainer
    );
  });
})();
